<template>
  <div>
    <h1 class="title">PANTALLA {{ numeroPantalla }} DATOS CUADRO</h1>

    <HmiPantalla>
      <div class="content">
        <div class="screen-title">
          <HmiLabel label="DATOS CUADRO" width="85%" height="100%" :size="4" color="cyan" border="solid 6px yellow">
          </HmiLabel>
          <div class="buttons">
            <HmiButton label="HELP" color="black" fontColor="lightgreen" border="solid 6px yellow"
              icon="mdi-phone-classic" width="100%" height="100%" :size="1.7"></HmiButton>
          </div>
        </div>
        <div class="grid">
          <div class="custom-row">
            <HmiLabel label="TENSION BATERIA" color="cyan" width="25%" height="80%" :size="1.7"></HmiLabel>
            <HmiLabel :label="formatoVA(tensionBateria) + ' V.'" color="silver" width="25%" height="80%" :size="1.7">
            </HmiLabel>
            <HmiLabel label="MAXIMA TENSION BAT." color="cyan" width="25%" height="80%" :size="1.7"></HmiLabel>
            <HmiLabel :label="formatoVA(hmiMaximaTensionBateria)" color="#56FF56" :editable="true" width="25%"
              height="80%" :size="1.7"
              @input="escrituraDM($event, direccionVariables.HMI_MAXIMA_TENSION_BATERIA_ESCRITURA, 1)"></HmiLabel>
          </div>
          <div class="custom-row">
            <HmiLabel label="INTENSIDAD CARGADOR" color="cyan" width="25%" height="80%" :size="1.7"></HmiLabel>
            <HmiLabel :label="formatoVA(intensidadCargadorBateria) + ' A.'" color="silver" width="25%" height="80%"
              :size="1.7"></HmiLabel>
            <HmiLabel label="MINIMA TENSION BAT." color="cyan" width="25%" height="80%" :size="1.7"></HmiLabel>
            <HmiLabel :label="formatoVA(hmiMinimaTensionBateria)" color="#56FF56" :editable="true" width="25%"
              height="80%" :size="1.7"
              @input="escrituraDM($event, direccionVariables.HMI_MINIMA_TENSION_BATERIA_ESCRITURA, 1)"></HmiLabel>
          </div>
          <div class="row-special">
            <div class="column">
              <HmiLabel label="AVISO TELEFONICO" color="cyan" width="100%" height="25%" :size="1.7">
              </HmiLabel>
              <div class="row2">
                <HmiButton label="FALTA RED" :color="faltaDeRed == '1' ? 'yellow' : 'silver'" width="50%" height="80%"
                  :size="1.7"></HmiButton>
                <HmiButton label="BLOQUEO" :color="bloqueo == '1' ? 'yellow' : 'silver'" width="50%" height="80%"
                  :size="1.7"></HmiButton>
              </div>
            </div>
            <div class="column2">
              <HmiLabel label="ALARMAS DESACTIVADAS" color="#FF00C0" width="100%" height="25%" :size="1.7">
              </HmiLabel>
              <div class="row2">
                <HmiButton label="HZ. RED" :color="hzRed == '1' ? '#FF00C0' : 'silver'" width="50%" height="80%"
                  :size="1.7"></HmiButton>
                <HmiButton label="POS. CORREA" :color="posCorrea == '1' ? '#FF00C0' : 'silver'" width="50%" height="80%"
                  :size="1.7">
                </HmiButton>
                <HmiButton label="NIV. GRASA" :color="nivelGrasa == '1' ? '#FF00C0' : 'silver'" width="50%" height="80%"
                  :size="1.7">
                </HmiButton>
              </div>
            </div>
          </div>
          <div class="custom-row">
            <HmiLabel label="28/08/2023" color="cyan" border="solid 6px yellow" width="40%" height="80%" :size="1.7">
            </HmiLabel>
            <HmiLabel label="8:19:01 AM" color="cyan" border="solid 6px yellow" width="40%" height="80%" :size="1.7">
            </HmiLabel>
            <HmiButton label="SALIR" color="silver" width="20%" height="80%" :size="1.7" @click.native="navigateToMenu">
            </HmiButton>
          </div>
        </div>
      </div>
    </HmiPantalla>
  </div>
</template>

<script>
import HmiLabel from "@/components/HMI/HmiLabel.vue";
import HmiButton from "@/components/HMI/HmiButton.vue";
import HmiPantalla from "@/components/HMI/HmiPantalla.vue";
export default {
  name: "DatosCuadroPantalla",
  computed: {
    // Obtenemos el numero de pantalla en la que estamos trabajandos
    numeroPantalla() {
      return this.$route.params.numeroPantalla;
    },

    direccionVariables() {
      return {
        TENSION_BATERIA_LECTURA: 47, // Correspondiente a Dm118
        INTENSIDAD_CARGADOR_BATERIA_LECTURA: 48, // Correspondiente a Dm120
        HMI_MAXIMA_TENSION_BATERIA_LECTURA: 127, // Correspondiente a Dm29
        HMI_MAXIMA_TENSION_BATERIA_ESCRITURA: "Dm0029", // Correspondiente a Dm29
        HMI_MINIMA_TENSION_BATERIA_LECTURA: 126, // Correspondiente a Dm28
        HMI_MINIMA_TENSION_BATERIA_ESCRITURA: "Dm0028", // Correspondiente a Dm28
      };
    },

    direccionVariablesBit() {
      if (this.numeroPantalla == 1) {
        return {
          FALTA_DE_RED_LECTURA: [143, 0], // Correspondiente a H0.00
          BLOQUEO_LECTURA: [143, 1], // Correspondiente a H0.01
          HZ_RED_LECTURA: [143, 2], // Correspondiente a H0.06
          POS_CORREA_LECTURA: [143, 3], // Correspondiente a H0.07
          NIVEL_GRASA_LECTURA: [143, 4], // Correspondiente a H0.08
        };
      } else {
        return {
          FALTA_DE_RED_LECTURA: [143, 0], // Correspondiente a H0.00
          BLOQUEO_LECTURA: [143, 5], // Correspondiente a H0.02
          HZ_RED_LECTURA: [143, 6], // Correspondiente a H0.09
          POS_CORREA_LECTURA: [143, 5], // Correspondiente a H0.10
          NIVEL_GRASA_LECTURA: [143, 8], // Correspondiente a H0.11
        };
      }
    },

    tensionBateria() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.TENSION_BATERIA_LECTURA
        ];
      }
      return "0000";
    },
    intensidadCargadorBateria() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.INTENSIDAD_CARGADOR_BATERIA_LECTURA
        ];
      }
      return "0000";
    },
    hmiMaximaTensionBateria() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.HMI_MAXIMA_TENSION_BATERIA_LECTURA
        ];
      }
      return "0000";
    },
    hmiMinimaTensionBateria() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.HMI_MINIMA_TENSION_BATERIA_LECTURA
        ];
      }
      return "0000";
    },
    faltaDeRed() {
      if (this.direccionVariablesBit) {
        let word =
          this.$store.state.lecturas[
          this.direccionVariablesBit.FALTA_DE_RED_LECTURA[0]
          ];
        return this.obtenerBit(
          word,
          this.direccionVariablesBit.FALTA_DE_RED_LECTURA[1]
        );
      }
      return "0";
    },
    bloqueo() {
      if (this.direccionVariablesBit) {
        let word =
          this.$store.state.lecturas[
          this.direccionVariablesBit.BLOQUEO_LECTURA[0]
          ];
        return this.obtenerBit(
          word,
          this.direccionVariablesBit.BLOQUEO_LECTURA[1]
        );
      }
      return "0";
    },
    hzRed() {
      if (this.direccionVariablesBit) {
        let word =
          this.$store.state.lecturas[
          this.direccionVariablesBit.HZ_RED_LECTURA[0]
          ];
        return this.obtenerBit(
          word,
          this.direccionVariablesBit.HZ_RED_LECTURA[1]
        );
      }
      return "0";
    },
    posCorrea() {
      if (this.direccionVariablesBit) {
        let word =
          this.$store.state.lecturas[
          this.direccionVariablesBit.POS_CORREA_LECTURA[0]
          ];
        return this.obtenerBit(
          word,
          this.direccionVariablesBit.POS_CORREA_LECTURA[1]
        );
      }
      return "0";
    },
    nivelGrasa() {
      if (this.direccionVariablesBit) {
        let word =
          this.$store.state.lecturas[
          this.direccionVariablesBit.NIVEL_GRASA_LECTURA[0]
          ];
        return this.obtenerBit(
          word,
          this.direccionVariablesBit.NIVEL_GRASA_LECTURA[1]
        );
      }
      return "0";
    },
  },
  components: {
    HmiLabel,
    HmiButton,
    HmiPantalla,
  },
  methods: {
    // Navegación a "Menu"
    navigateToMenu() {
      this.$router.push(`/pantalla/${this.numeroPantalla}`);
    },

    // Emitir evento salida
    mandarSalida() {
      this.$emit("mandar-pagina", "pagina/salida", "9", "");
    },

    // Emitir evento entrada
    mandarEntrada() {
      this.$emit("mandar-pagina", "pagina/entrada", "9", "");
    },

    formatoVA(dato) {
      return dato.substring(1, 3) + "." + dato.substring(3, 4);
    },

    //Obtener bit
    obtenerBit(dato, posicion) {
      let intValue = parseInt(dato, 16);

      let binaryString = intValue.toString(2).padStart(16, "0");

      let bit = binaryString.charAt(binaryString.length - 1 - posicion);
      return bit;
    },

    formatNumber(numberString, decimalPlaces) {
      // Convertir el número de cadena a un número decimal con el número especificado de decimales
      let number = parseFloat(numberString).toFixed(decimalPlaces);

      // Eliminar el punto decimal del número
      let noDecimal = number.replace(".", "");

      // Rellenar el número con ceros a la izquierda hasta alcanzar una longitud de 4 caracteres
      let paddedNumber = noDecimal.padStart(4, "0");

      return paddedNumber;
    },

    escrituraDM(value, direccion, canales) {
      value = this.formatNumber(value, 1);
      direccion = direccion.substring(2);
      const payload = {
        name: "escrituraDM",
        direccion: direccion,
        valor: value.padStart(4 * canales, "0"),
      };
      this.$emit("mandar-escritura", payload);
    },
  },
  mounted() {
    //Mandar a nodered entrada
    this.mandarEntrada();
    //Cuando se cierre la ventana enviar señal
    window.addEventListener("unload", this.mandarSalida);
  },
  destroyed() {
    //Mandar a nodered salida
    this.mandarSalida();
  },
};
</script>

<style scoped>
.title {
  font-family: "Courier New", Courier, monospace !important;
  text-align: center;
  margin: 20px 20px 0px 20px;
}

.content {
  height: 100%;
}

.screen-title {
  display: flex;
  justify-content: center;
  gap: clamp(1px, 2vw - 5px, 20px);
  height: 15%;
}

.grid {
  display: flex;
  flex-direction: column;
  padding-top: 20px;
  height: 85%;
  gap: clamp(1px, 2vw - 5px, 20px);
}

.buttons {
  display: flex;
  height: 100%;
  gap: clamp(1px, 2vw - 5px, 20px);
  width: 15%;
}

.custom-row {
  height: 22%;
  display: flex;
  gap: clamp(1px, 2vw - 5px, 20px);
  width: 100%;
  justify-content: space-between;
}

.row-special {
  height: 33%;
  display: flex;
  gap: clamp(1px, 2vw - 5px, 20px);
  width: 100%;
  justify-content: space-between;
}

.column {
  width: 40%;
  display: flex;
  flex-direction: column;
  gap: clamp(1px, 2vw - 5px, 20px);
}

.column2 {
  width: 60%;
  display: flex;
  flex-direction: column;
  gap: clamp(1px, 2vw - 5px, 20px);
}

.row2 {
  height: 75%;
  display: flex;
  gap: clamp(1px, 2vw - 5px, 20px);
}
</style>
